import { useContext, useState } from "react";
import { StandardButton } from "../atoms/buttons";
import { User } from "../atoms/user";
import { PageContext } from "../App";
import { icon } from "../functions/icons";

export function ChatTopBar({ user, goBack, chatData, handleChatArchive }) {
  const navigationContext = useContext(PageContext);
  const [archived, setArchived] = useState(chatData?.archived || 0)
  const toggleArchive = () => {
    handleChatArchive(chatData.id_course, archived === 0);
    setArchived(archived === 0 ? 1 : 0);
  };

  return (
    <div aria-label="chat-top-bar" className="horizontal card-background-color chat-top-bar complete-width space-between ">
      {goBack && (
        <button data-testid={"button-goback"} onClick={goBack} className="back-button">
          {icon("arrow-left")}
        </button>
      )}
      <User avatar={`${chatData?.image_url}`} name={chatData?.title || ""} email={""} />
      <div className="horizontal chat-button" style={{ width: "unset" }}>
        <StandardButton
          onClick={() =>
            navigationContext.handleNavigation({
              navigation: 7,
              courseID: user.id_course,
              enrollment: 0,
            })
          }
          title={"Ga naar cursus"}
        />
        <StandardButton onClick={toggleArchive} title={archived === 1 ? "Unarchive" : "Archive"} />
      </div>
    </div>
  );
}
